module.exports = __webpack_public_path__ + "static/img/casino-logo.79fb51c.png";